import React from 'react';
import Navbar from '../Navbar/Navbar';
import Services from '../Services/Services';
import Footer from '../Footer/Footer';

const ServicesPage = () => {
  return (
    <div className='services-page'>
      <Navbar />
      <Services />
      <Footer />
    </div>
  );
};

export default ServicesPage;
